import { MedicalReportResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export class MedicalReports extends DataModel<MedicalReportResponse> {
  constructor(
    data: MedicalReportResponse[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    // access
    this.access = {
      editRules: {
        medical: AccessRules.owner,
        monitoring: AccessRules.visible,
      },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: false,
    };
  }
}
